<template>
  <section class="product-section">
    <h2 class="product-section-title">Specification</h2>
    <div class="table-responsive px-3">
      <table class="spec-table">
        <tbody>
          <Tr
            v-if="specificationTrShow('inch')"
            th="Length<br>( inch )"
            name="inch"
            :specification="specification"
          />
          <Tr
            v-if="specificationTrShow('mm')"
            th="Length<br>( mm )"
            name="mm"
            :specification="specification"
          />
          <Tr
            v-if="specificationTrShow('claw')"
            th="Claw"
            name="claw"
            :specification="specification"
          />
          <Tr
            v-if="specificationTrShow('width')"
            th="Width<br>( Rubber )"
            name="width"
            :specification="specification"
          />
          <Tr
            v-if="specificationTrShow('thickness')"
            th="Thickness<br>( Frame )"
            name="thickness"
            :specification="specification"
          />
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import Tr from "./_specification_tr";

export default {
  props: ["specification", "tr"],
  components: { Tr },
  methods: {
    specificationTrShow(item) {
      return Object.keys(this.specification[0]).find(v => v === item)
    },
  },
};
</script>

<style lang="scss">
.spec-table {
  width: 90%;
  text-align: center;
  color: rgba(91, 90, 90, 1);
  font-size: 14px;
  border: 1px solid $color-main;

  tr:last-child th {
    border-bottom-color: $color-main;
  }

  th {
    width: 14%;
    padding-top: 5px;
    padding-bottom: 5px;
    vertical-align: middle;
    color: #fff;
    background-color: $color-main;
    border-bottom: 1px solid #fff;
  }

  tr:not(:last-child) td {
    border-bottom: 1px solid $color-main;
  }
  td:not(:last-child) {
    border-right: 1px solid $color-main;
  }
}
</style>